import React, { useEffect, useState } from 'react';
import SEO from '../components/SEO';
import { Btn } from '../components/design-system';

const SEQUENCE = [
  '> Error 404: Route not found.',
  '> Establishing secure connection to main server...',
  '> Connection refused.',
  '> Action required: Rebooting sequence initiated...',
  '> Redirecting to Home...',
].join('\n');

const NotFound: React.FC = () => {
  const [text, setText] = useState('');

  useEffect(() => {
    let i = 0;
    const id = window.setInterval(() => {
      if (i < SEQUENCE.length) {
        setText(SEQUENCE.substring(0, i + 1));
        i++;
      } else {
        window.clearInterval(id);
      }
    }, 40);
    return () => window.clearInterval(id);
  }, []);

  return (
    <>
      <SEO title="404 Not Found" description="The page you are looking for does not exist." />
      <section
        className="ds-section"
        style={{
          minHeight: '70vh',
          display: 'grid',
          placeItems: 'center',
          paddingTop: 48,
          paddingBottom: 48,
        }}
      >
        <div className="ds-wrap" style={{ maxWidth: 720 }}>
          <div className="dash">
            <div className="dash__bar">
              <span className="dot g" />
              <span className="dot y" />
              <span className="dot r" />
              <span className="title">bash · consult-sre · 80×24</span>
            </div>
            <div
              style={{
                padding: 28,
                fontFamily: 'var(--font-mono)',
                fontSize: 13,
                color: 'var(--accent)',
                lineHeight: 1.8,
                whiteSpace: 'pre-line',
                minHeight: 220,
              }}
            >
              {text}
              <span style={{ animation: 'blink 1s step-end infinite' }}>_</span>
            </div>
            <div
              style={{
                borderTop: '1px solid var(--line)',
                padding: 20,
                textAlign: 'center',
              }}
            >
              <Btn variant="primary" to="/">
                [ execute: return_to_base ]
              </Btn>
            </div>
          </div>
        </div>
        <style>{`@keyframes blink { 0%,100% { opacity: 1 } 50% { opacity: 0 } }`}</style>
      </section>
    </>
  );
};

export default NotFound;
